import { EllipsisVertical, FileTextIcon, Pencil, Trash } from 'lucide-react'

import { DropdownMenu, IconButton } from 'slab'

import { type OnboardingEnrollment, type Step } from '../types'

type EnrollmentSidebarCardDropdownProps = {
  enrollment: OnboardingEnrollment;
  onRemovePlan?: () => void;
  navigateToSpecificStep?: (step: Step) => void;
}

const EnrollmentSidebarCardDropdown = ({
  enrollment,
  navigateToSpecificStep,
  onRemovePlan,
}: EnrollmentSidebarCardDropdownProps) => {
  const hasPlanDetails =
    enrollment.covers_medical && enrollment.payment_method === 'paid_by_thatch'
  const onChangePlanSelection = () => {
    if (enrollment.covers_vision) {
      navigateToSpecificStep?.('vision_plan')
    } else if (enrollment.covers_dental) {
      navigateToSpecificStep?.('dental_plan')
    } else {
      navigateToSpecificStep?.('medical_plan')
    }
  }

  // This function is only available for on thatch medical plan cards
  const onSelectPlanDetails = () => {
    navigateToSpecificStep?.(`medical_plan_details:${enrollment.plan_code}`)
  }

  return (
    <DropdownMenu
      align='end'
      trigger={<IconButton label='See more options' icon={EllipsisVertical} />}
    >
      <DropdownMenu.Item leftIcon={Pencil} onSelect={onChangePlanSelection}>
        Change plan selection
      </DropdownMenu.Item>
      {hasPlanDetails && (
        <DropdownMenu.Item
          leftIcon={FileTextIcon}
          onSelect={onSelectPlanDetails}
        >
          View plan details
        </DropdownMenu.Item>
      )}
      {onRemovePlan && (
        <DropdownMenu.Section>
          <DropdownMenu.Item
            leftIcon={Trash}
            type='destructive'
            onSelect={onRemovePlan}
          >
            Remove plan
          </DropdownMenu.Item>
        </DropdownMenu.Section>
      )}
    </DropdownMenu>
  )
}

export default EnrollmentSidebarCardDropdown
